import { validateEmail } from "../../../../utils/validations";

//prettier-ignore
export const validateDelegate = (delegate: any, isCreate: boolean, pickedCenter: any) => {
    if (!delegate.fullName) return "Por favor escriba el nombre del delegado";
    if (!pickedCenter && isCreate) return "Por favor elija un centro";
    if (!delegate.email || !validateEmail(delegate.email)) return "Por favor escriba el email del delegado";
    return ""
  };
